module.exports = __webpack_public_path__ + "static/img/group11.2cc0d51.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Gotit/group11.png
// module id = ZweE
// module chunks = 0